import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css'; // Global CSS
import NavbarInicial from './components/Navbar';
import Footer2 from './components/Footer2';
import Inicio from './components/Inicio';
import AbmCarousel from './components/carousel/AbmCarousel';
import Login from './components/login/Login';
import NotFound from './components/NotFound';
import PanelDeControl from './components/PanelDeControl';
import TablaAbmEventos from './components/eventos/TablaAbmEventos';
import CrearEventosForm from './components/eventos/CrearEventoForm';
import EditarEventoForm from './components/eventos/EditarEventoForm';
import TablaAbmRestoYBar from './components/restoybar/TablaAbmRestoYBar';
import CrearCategoriaRestoyBar from './components/restoybar/CrearCategoriaRestoyBar';
import CrearProductoRestoyBar from './components/restoybar/CrearProductoRestoyBar';
import { AuthProvider } from './components/login/AuthContext';
import { ProtectedRoute } from './components/login/ProtectedRoute';
import { UnProtectedRoute } from './components/login/UnprotectedRoute';
import TyC from './components/TyC';
import PoliticaDePrivacidad from './components/PoliticaDePrivacidad';

function App() {
  return (
    <div style={{ backgroundColor: "#f0ecec" }}>
      <AuthProvider>
        <BrowserRouter>
          {/* Navbar arriba de las paginas */}
          <NavbarInicial />
          <Routes>
            {/* Rutas Predefinidas */}
            <Route path="/" element={<Inicio />} />
            <Route path="/terminosycondiciones" element={<TyC />} />
            <Route path="/politicadeprivacidad" element={<PoliticaDePrivacidad />} />
            {/* Rutas que necesitan que el usuario no este logueado */}
            <Route
              path="/login"
              element={
                <UnProtectedRoute>
                  <Login />
                </UnProtectedRoute>
              }
            />
            {/* Rutas que necesitan que el usuario este logueado */}
            <Route
              path="/paneldecontrol"
              element={
                <ProtectedRoute>
                  <PanelDeControl />
                </ProtectedRoute>
              }
            />
            <Route
              path="/imageBackend"
              element={
                <ProtectedRoute>
                  <AbmCarousel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/administradorEventos"
              element={
                <ProtectedRoute>
                  <TablaAbmEventos />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crearEvento"
              element={
                <ProtectedRoute>
                  <CrearEventosForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/editarEvento"
              element={
                <ProtectedRoute>
                  <EditarEventoForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/administradorRestoYBar"
              element={
                <ProtectedRoute>
                  <TablaAbmRestoYBar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crearCategoriaRestoyBar"
              element={
                <ProtectedRoute>
                  <CrearCategoriaRestoyBar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crearProductoRestoyBar"
              element={
                <ProtectedRoute>
                  <CrearProductoRestoyBar />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
          {/* Footer debajo de las paginas */}
          <Footer2 />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
